import React, { Component, Fragment } from "react";
import { withTranslation } from "react-i18next";
import Wrapper from "./../../../common/component/Wrapper";
import * as Func from "../../../../../helpers/functions";
import {
  FilterDropdown,
  ListComponent,
  StatusComponent,
} from "../../../common/component/Index";
import { Icon, Tooltip } from "antd";
import { PATHS } from "../../../../../constants/Define";
import { Link } from "react-router-dom";
import Modal from "../../../common/component/Modal";
import EllipsisText from "../../../common/component/EllipsisText";
import VinwonderTagGroup from "models/VinWonderTagGroup";
import { FlagIcons } from "containers/backend/common/component/TranslateButton";
import { getContentLanguage } from '../../../../../utils/commonUtils';
import { normalizeVinWonderTagGroups } from "../helpers";

const defaultState = {};

const ListCols = [
  "name",
  "codeIndex",
  "description",
  "supplierNamesConfiged",
  "totalSkuConfiged",
  "isActive",
  "translations",
];
const ModelFields = Object.getOwnPropertyNames(new VinwonderTagGroup());

class CategoryList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ...defaultState,
      titleItemTable: Func.getTitleTable(ListCols, ["action"], ["description"]),
      modelItem: ModelFields,
      componentTable: {
        name: {
          key: "name",
          filterDropdown: ({
            setSelectedKeys,
            selectedKeys,
            confirm,
            clearFilters,
          }) => (
            <FilterDropdown
              setSelectedKeys={setSelectedKeys}
              selectedKeys={selectedKeys}
              confirm={confirm}
              clearFilters={clearFilters}
            ></FilterDropdown>
          ),
          filterIcon: (filtered) => (
            <Icon
              type="search"
              style={{ color: filtered ? "#1890ff" : undefined }}
            />
          ),
          render: (name, record) =>
            name && (
              <EllipsisText
                title={name}
                content={name}
                contentMaxWidth={600}
                overlayClassName={"max-width-500"}
                overlayComponent={Tooltip}
              />
            ),
        },
        supplierNamesConfiged: {
          key: "supplierNamesConfiged",
          render: (text, record) => (
            <Tooltip title={record.supplierNamesConfiged}>
              <Icon type="info-circle" />
            </Tooltip>
          ),
        },
        codeIndex: {
          key: "code",
          filterDropdown: ({
            setSelectedKeys,
            selectedKeys,
            confirm,
            clearFilters,
          }) => (
            <FilterDropdown
              setSelectedKeys={setSelectedKeys}
              selectedKeys={selectedKeys}
              confirm={confirm}
              clearFilters={clearFilters}
            ></FilterDropdown>
          ),
          filterIcon: (filtered) => (
            <Icon
              type="search"
              style={{ color: filtered ? "#1890ff" : undefined }}
            />
          ),
          render: (text, record) => <p>{record.code}</p>,
        },
        totalSkuConfiged: {
          key: "totalSkuConfiged",
        },
        isActive: {
          key: "isActive",
          render: (isActive) => (
            <StatusComponent
              color={isActive ? "green" : "red"}
              label={
                isActive
                  ? this.props.t("item.promotions.active")
                  : this.props.t("item.promotions.deactive")
              }
            />
          ),
          filters: [
            { value: true, text: this.props.t("item.promotions.active") },
            { value: false, text: this.props.t("item.promotions.deactive") },
          ],
          filterMultiple: false,
        },
        translations: {
          key: "translations",
          render: (text, record) => (
            <FlagIcons languages={record.translations} />
          ),
        },
        action: {
          width: 100,
          align: "center",
          key: "action",
          render: (text, record) => this.renderEditComponent(record),
        },
      },
    };
  }

  renderEditComponent(item) {
    const { t, permisions } = this.props;
    const removeCategory = () => {
      return (
        this.props.onDeleteSupplierCategory &&
        this.props.onDeleteSupplierCategory(item)
      );
    };
    const onRemove = () => {
      const { confirm } = Modal;
      confirm({
        title: Func.formatValidation(
          t("validation.statusCode.code.7"),
          t(`item.supplierCategory.title`)
        ),
        content: item.name,
        okText: t(`action.remove`),
        cancelText: t(`action.cancel`),
        onOk: removeCategory,
      });
    };
    return (
      <Fragment>
        {permisions && permisions.allowUpdate && (
          <Link
            to={Func.getPathWithParams(PATHS.TAG_GROUP_VW.DETAIL.path, {
              id: item.id,
            })}
            className={`mr-2`}
          >
            <Icon type="form" className="fs20 mr-1" />
          </Link>
        )}
      </Fragment>
    );
  }

  render() {
    const { t, loading, pagination, supplierCategories } = this.props;
    const { titleItemTable, modelItem, componentTable } = this.state;
    const langCode = getContentLanguage();

    const transformedData = normalizeVinWonderTagGroups(supplierCategories || [], langCode);
    return (
      <Wrapper className="mt-2">
        <ListComponent
          tableKey="ticket-list"
          classParent="m-0 p-0 col-md-12"
          classChildren="p-0"
          marginTop={"0"}
          marginBottom={"0"}
          loading={{ spinning: loading, size: "large" }}
          rowKey={(record, k) => (record.id ? record.id : k)}
          dataSource={Func.getDataSource(transformedData || [], modelItem)}
          columns={Func.columnsTable({
            titleTable: titleItemTable,
            component: componentTable,
            itemName: "vinwondertaggroup",
          })}
          pagination={{
            total: pagination.totalCount,
            totalPage: pagination.totalPage,
            defaultCurrent: pagination.defaultCurrent,
            pageSize: pagination.pageSize,
          }}
          onChange={this.props.onChange}
          componentTableList={{}}
        />
      </Wrapper>
    );
  }
}

export default withTranslation()(CategoryList);
